// extracted by mini-css-extract-plugin
module.exports = {"section":"_3GjYce5timzHg27etjCa9K"};